import { render, staticRenderFns } from "./BpCashInFlowTable.vue?vue&type=template&id=23576305"
import script from "./BpCashInFlowTable.vue?vue&type=script&lang=ts"
export * from "./BpCashInFlowTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports